<template>
  <BackupComponent />
</template>

<script lang="ts">
import BackupComponent from "@/components/Backup/Backup.vue";
import { defineComponent } from "vue";

const componentName = "BackupRoute";

export default defineComponent({
  name: componentName,
  components: { BackupComponent },
});
</script>
